define('view/module/review/ReviewListModuleView',['require','marionette','view/module/review/ReviewListModuleItemView','view/module/review/ReviewModuleEmptyView'],function (require) {

    var Marionette = require('marionette');
    var ReviewListModuleItemView = require('view/module/review/ReviewListModuleItemView');
    var ReviewModuleEmptyView = require('view/module/review/ReviewModuleEmptyView');

    /**
     * Reviews composite module view (reviews container)
     *
     * @class ReviewListModuleView
     */
    return Marionette.CompositeView.extend({

        template: '#reviews_list_module_view',
        childView: ReviewListModuleItemView,
        emptyView: ReviewModuleEmptyView,
        childViewContainer: '#sb_reviews_list_items_module_container',
/*        childViewOptions: function(model, index) {
            return {
                logged_in: this._reviewModel.get('logged_in'),
                childIndex: index
            }
        },*/
        collectionEvents: {
            sync: 'render'
        },

        ui : {
            'page' : '#sb_reviews_list_paginator a',
        },

/*
        childEvents: {
            'like_review': 'onLikeReview',
            'dislike_review': 'onDislikeReview'
        },
*/

        events: {
            'click @ui.page': 'onPaginatorClick',
        },

        initialize : function () {
/*            this._reviewModel = this.getOption('reviewModel');
            this.listenTo(this._reviewModel, 'change', this.render);*/
        },

        onPaginatorClick : function (e) {
            var page = jQuery(e.currentTarget).data('page');
            if(page) {
                this.collection.setPage(page);
                this.collection.reloadPage();
                this._onPageChanged();
            }
            return false;
        },

/*        onLikeReview: function(view, data) {
            data.model.likeReview();
        },

        onDislikeReview: function(view, data) {
            data.model.dislikeReview();
        },*/

        serializeData: function () {
            var result = Marionette.CompositeView.prototype.serializeData.apply(this);
            var pageInfo = this.collection.pageInfo();
            return _.extend(pageInfo, result);
        },

        _onPageChanged: function () {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'reviews',
                'type' : 'page',
            });
        },

        onDomRefresh: function () {
            Backbone.Wreqr.radio.vent.trigger('module', 'shown', {
                'module': 'reviews'
            });
        }

    });

});
